module.exports = __webpack_public_path__ + "img/map.5beacf64.png";